import styled from 'styled-components';

export const Container = styled.div`
  width: 1260px;
  padding: 0 20px;
  margin: 0 auto;
`;
